import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export const SparklesIcon = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ _jsx("svg", {
        ref: ref,
        ...props,
        fill: "none",
        "aria-hidden": "true",
        viewBox: "0 0 32 32",
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            stroke: "currentColor",
            "stroke-width": "2",
            d: "M14.4883 16.4424C14.6288 16.9637 15.0363 17.3712 15.5576 17.5117L21.4336 19.0938L15.5576 20.6758C15.1016 20.7987 14.7329 21.1257 14.5537 21.5547L14.4883 21.7451L12.9062 27.6201L11.3242 21.7451L11.2598 21.5547C11.0805 21.1255 10.7112 20.7986 10.2549 20.6758L4.37891 19.0938L10.2549 17.5117C10.7763 17.3713 11.1837 16.9637 11.3242 16.4424L12.9062 10.5654L14.4883 16.4424ZM24.7373 6.19238C24.8777 6.71397 25.286 7.12226 25.8076 7.2627L27.6201 7.75098L25.8076 8.23926C25.3514 8.3621 24.982 8.68903 24.8027 9.11816L24.7373 9.30859L24.249 11.1211L23.7607 9.30859L23.6963 9.11816C23.5171 8.68897 23.1477 8.36211 22.6914 8.23926L20.8779 7.75098L22.6914 7.2627C23.213 7.12226 23.6203 6.71397 23.7607 6.19238L24.249 4.37891L24.7373 6.19238Z"
        })
    }));
SparklesIcon.displayName = "SparklesIcon";
